import PropTypes from 'prop-types';
import React from 'react';
import ClassNames from 'classnames';
import TextArea from 'views/ui/form_elements/textarea';
import Dimmer from 'views/shared/ui/dimmer';
import './index.scss';

class BookingReviewMessage extends React.PureComponent {
  static displayName = 'BookingReview-Message-AnyGuide';

  static propTypes = {
    reasonProps: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    handleCancelClicked: PropTypes.func.isRequired,
    rejecting: PropTypes.bool.isRequired,
    rejectingCompleted: PropTypes.bool.isRequired,
    rejectingError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    guest_firstname: PropTypes.string.isRequired,
  };

  static defaultProps = {
    theme: 't-Default',
    rejectingError: null,
  };

  render() {
    var containerClasses = ClassNames('MessageContainer', this.props.theme);

    return (
      <div className={containerClasses}>
        <Dimmer loader={true} active={this.props.rejecting} />
        <p className="lead">
          <strong>Decline Booking</strong>
        </p>
        <p>
          Please let {this.props.guest_firstname} know why you are declining
        </p>
        <div className="Message-TextAreaContainer">
          <TextArea {...this.props.reasonProps} />
        </div>
        <div className="Message-Actions">
          <a
            href="#"
            onClick={this.props.handleCancelClicked}
            className="btn cancel"
          >
            Cancel
          </a>
          <a href="#" onClick={this.props.onSubmit} className="btn submit">
            Send
          </a>
        </div>
      </div>
    );
  }
}

export default BookingReviewMessage;
